<template>
    <span :class="['status-label', 'invoice', statusName, size]">
        <span class="text">
            <span>{{ statusTxt }}</span>
            <span v-if="count !== null" class="count">{{ count }}</span>
        </span>
    </span>
</template>
<script>
import _ from 'lodash';
import { invoiceStatus } from '@/assets/commonData/options';

export default {
    name: 'invoice-status-label',
    props: {
        statusNum: {
            type: Number,
            default: () => 0,
        },
        count: {
            type: Number,
            default: () => null,
        },
        size: {
            type: String,
            default: 'normal',
        },
    },
    computed: {
        statusTxt() {
            return _.find(invoiceStatus, ['key', this.statusNum])?.value;
        },
        statusName() {
            return _.find(invoiceStatus, ['key', this.statusNum])?.name;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.invoice.status-label {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    border-radius: 13px;
    background-color: #eee;
    white-space: nowrap;

    > .text {
        font-size: 9.5pt;
        font-weight: 500;

        .count {
            opacity: 0.5;
            margin-left: 7px;
            font-weight: bold;
        }
    }

    &.pending {
        background-color: #ffe36c;
        color: #4d2c06;
    }

    &.wait-for-pay {
        background-color: #463cb2;
        color: #fff;
    }

    &.to-be-pass {
        background-color: #dae0ff;
        color: #1f3190;
    }

    &.done {
        background-color: #def5d6;
        color: #0baa1b;
    }

    &.reject {
        background-color: #ffe8e8;
        color: #ff2c2c;
    }

    &.cancel {
        background-color: #f4f4f4;
        color: #848484;
    }
}
</style>
